module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.is-object.js
// module id = 111
// module chunks = 0